import styled from 'styled-components';

interface imageProps {
  image?: string;
}

export const ImagePlaceholder = styled.div`
  background-image: url(${(props: imageProps) => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-color: #000000;
  width: 100%;
  height: 250px;
`;

export const UserBlock = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  align-items: center;
`;
